import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PageLoader } from "@/components/StateViews";
import { AppLayout } from "@/components/AppLayout";
import { LoginPage } from "@/pages/LoginPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { TippingPage } from "@/pages/TippingPage";
import { KnockoutPage } from "@/pages/KnockoutPage";
import { ChampionPickPage } from "@/pages/ChampionPickPage";
import { LeaderboardPage } from "@/pages/LeaderboardPage";
import { MyTipsPage } from "@/pages/MyTipsPage";
import { BadgesPage } from "@/pages/BadgesPage";
import { StatsPage } from "@/pages/StatsPage";
import { LeaguesPage } from "@/pages/LeaguesPage";
import { ArchivePage } from "@/pages/ArchivePage";
import { ProfilePage } from "@/pages/ProfilePage";

// Az admin csak a jogosult felhasználóknak kell — külön bundle-ben, igény szerint töltve.
const AdminLayout = lazy(() => import("@/pages/admin/AdminLayout").then((m) => ({ default: m.AdminLayout })));
const AdminTournamentsPage = lazy(() => import("@/pages/admin/AdminTournamentsPage").then((m) => ({ default: m.AdminTournamentsPage })));
const AdminTeamsPage = lazy(() => import("@/pages/admin/AdminTeamsPage").then((m) => ({ default: m.AdminTeamsPage })));
const AdminGroupsPage = lazy(() => import("@/pages/admin/AdminGroupsPage").then((m) => ({ default: m.AdminGroupsPage })));
const AdminMatchesPage = lazy(() => import("@/pages/admin/AdminMatchesPage").then((m) => ({ default: m.AdminMatchesPage })));
const AdminUsersPage = lazy(() => import("@/pages/admin/AdminUsersPage").then((m) => ({ default: m.AdminUsersPage })));

export default function App() {
  return (
    <Routes>
      <Route path="/belepes" element={<LoginPage />} />
      <Route path="/regisztracio" element={<RegisterPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Navigate to="/tippeles" replace />} />
          <Route path="/tippeles" element={<TippingPage />} />
          <Route path="/kieseses" element={<KnockoutPage />} />
          <Route path="/bajnoki-tipp" element={<ChampionPickPage />} />
          <Route path="/tabella" element={<LeaderboardPage />} />
          <Route path="/tippjeim" element={<MyTipsPage />} />
          <Route path="/kituzok" element={<BadgesPage />} />
          <Route path="/statisztika" element={<StatsPage />} />
          <Route path="/ligak" element={<LeaguesPage />} />
          <Route path="/archivum" element={<ArchivePage />} />
          <Route path="/profil" element={<ProfilePage />} />
        </Route>
      </Route>

      <Route element={<ProtectedRoute requireAdmin />}>
        <Route path="/admin" element={<Suspense fallback={<PageLoader />}><AdminLayout /></Suspense>}>
          <Route index element={<Navigate to="/admin/bajnoksagok" replace />} />
          <Route path="bajnoksagok" element={<AdminTournamentsPage />} />
          <Route path="csapatok" element={<AdminTeamsPage />} />
          <Route path="csoportok" element={<AdminGroupsPage />} />
          <Route path="meccsek" element={<AdminMatchesPage />} />
          <Route path="felhasznalok" element={<AdminUsersPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
